import * as React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import axios from 'axios';
import authService from './api-authorization/AuthorizeService';

export class Home extends React.Component<RouteComponentProps<{}>, {}> {
    constructor(props: any) {
        super(props);
    }

    componentDidMount() {
        this.getData();
    }

    async getData() {
        const token = await authService.getAccessToken();
        const user = await authService.getUser();

        axios.get('api/User/IsDriverSystem?SubId=' + user.sub, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        })
        .then(res => {
            var driverSystem = res.data;
            if (driverSystem) {
                this.props.history.push("/driverjobs");
            }
        });
    }

    public render() {
        return <div>
            <p>Welcome to the Super Safe Hire Dash Management System - Version 15.08</p>
        </div>
    }
}